var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{class:{ 'is-empty': _vm.isEmpty },attrs:{"colspan":_vm.colspan}},[(!_vm.isEmpty)?[_vm._v(" "+_vm._s(_vm.cellValue || '—')+" ")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }